import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ServiceMiniEntity } from '../../domain/entities/ServiceMiniEntity'
import type { ServiceAdminDto } from '@/backend/market'

export class ServiceMiniModel extends ServiceMiniEntity {
  constructor(dataDto: ServiceAdminDto) {
    super()
    mapEntityProperties<ServiceMiniModel>(this, dataDto, {
      map: {
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        }
      }
    })
  }
}
